<template>
  <v-card align="center" justify="center" min-width="30vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title>
          <h2>{{ $t('title_TournamentParticipants') }}</h2>
        </v-list-item-title>
        <v-spacer />
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-3 pb-5 pt-1">
      <v-overlay :dark="false" :absolute="true" :value="overlayProcessing"><v-progress-circular :size="70" width="5"
          indeterminate /></v-overlay>
      <v-container v-if="view === 'GENERAL'" fluid>
        <v-row class="mx-3" align="center" justify="center">
          <h2>{{ $t('subtitle') }}</h2>
          <v-btn v-if="new Date($store.state.tournament.endTime) > new Date()" class=" ml-3" @click="openAddView"
            small>
            {{ $t('btnAdd_TournamentParticipants') }} <v-icon class="ml-2" color="white" small>fa-plus</v-icon></v-btn>
          <v-spacer />
          <v-text-field :label="$t('hintSearch')" prepend-icon="fa-search" v-model="search" />
        </v-row>
        <v-data-table style="min-width: 42vw; background-color: transparent !important;" :items="participantsList" :headers="headers"
          hide-default-footer dense :search="search" :loading="loadingParticipants"
          :no-data-text="$t('noParticipants_TournamentParticipants')">
          <template v-slot:item.score="{ item }">
            <p class="mb-0">{{ (item.score !== null) ? item.score.toFixed(2) : 0 }}</p>
          </template>
          <template v-slot:item.status="{ item }">
            <DisqualificationTooltip
              v-if="item.status === 'DISQUALIFIED'"
              :participant-id="item.participantId"
              position="top"
            >
              <v-chip :color="statusColor(item.status)" x-small>{{ getStatus(item.status) }}</v-chip>
            </DisqualificationTooltip>
            <v-chip v-else :color="statusColor(item.status)" x-small>{{ getStatus(item.status) }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-chip v-if="!tournamentEnded && item.status === 'ACTIVE'" x-small @click="goToUser(item, 'DISQUALIFY')">{{ $t('btnDisqualify')
              }}</v-chip>
            <v-chip v-else-if="!tournamentEnded && item.status !== 'ACTIVE'" x-small @click="goToUser(item, 'ACTIVATE')">{{ $t('btnActivate') }}</v-chip>
            <v-chip v-if="canSeeJournal" x-small class="ml-2" @click="seeJournal(item)">{{ $t('btnSeeJournal')
              }}</v-chip>
          </template>
        </v-data-table>
        <h4 v-if="participantsList.length > 10" class="my-7">And {{
          participantsList.length - 10 }} more tournament participants</h4>
        <v-chip @click="exportCSV" class="mt-2" small>{{ $t('btnDownload') }} <v-icon class="ml-2"
            x-small>fa-share</v-icon></v-chip>
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="close">{{ $t('btnClose_TournamentParticipants') }}</v-btn>
        </v-row>
      </v-container>
      <v-container v-else-if="view === 'ADD'" fluid>
        <h2 class="text-center my-3">{{ $t('add.title') }}</h2>
        <p class="text-center mb-10">{{ $t('add.description') }}</p>
        <v-autocomplete :items="this.$store.state.clubMembers" :label="$t('add.emailLabel')"
          :placeholder="$t('add.emailPlaceholder')" item-value="user.id" item-text="user.email" v-model="userId"
          @change="changedSelectedUser" outlined />
        <v-select :disabled="userId === 0" :items="userVerifiedBrokerAccounts" :label="$t('add.accountLabel')"
          :placeholder="$t('add.accountPlaceholder')" item-value="id" item-text="identifier" v-model="brokerAccountId"
          outlined />
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="initialView === 'ADD' ? close() : view = 'GENERAL'">« {{ initialView === 'ADD' ? $t('btnClose_TournamentParticipants') : $t('add.btnAll') }}</v-btn>
          <v-btn :disabled="userId === 0 || brokerAccountId === 0" class="ml-3" @click="addParticipant">{{
            $t('add.btnAdd')
            }}</v-btn>
        </v-row>
      </v-container>
      <v-container v-else-if="currentParticipant !== null" fluid>
        <h2 class="text-center mt-3">{{ view !== 'DISQUALIFY' ? $t('option.titleActivate')
          : isRemoveSelected ? $t('confirmRemove') : $t('option.titleDisqualify') }}
        </h2>
        <v-avatar size="100" class="my-7">
          <v-img :src="currentParticipant.profilePicture !== null ?
            currentParticipant.profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"
            contain></v-img>
        </v-avatar>
        <!-- SFB-1205: same member action offers Disqualify and Remove pre-start. -->
        <v-radio-group v-if="view === 'DISQUALIFY' && tournamentNotStarted" v-model="memberActionChoice"
          class="mt-0 member-action-choice" hide-details>
          <v-radio value="DISQUALIFY" color="mainGreen">
            <template v-slot:label>
              <div>
                <strong>{{ $t('memberActionDisqualify') }}</strong>
                <div class="member-action-hint">{{ $t('memberActionDisqualifyHint') }}</div>
              </div>
            </template>
          </v-radio>
          <v-radio value="REMOVE" color="error" class="mt-2">
            <template v-slot:label>
              <div>
                <strong>{{ $t('memberActionRemove') }}</strong>
                <div class="member-action-hint">{{ $t('memberActionRemoveHint') }}</div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
        <p class="text-center mt-4">
          {{ view !== 'DISQUALIFY' ? $t('option.descriptionActivate', { name: currentParticipant.firstName })
            : isRemoveSelected ? $t('confirmRemoveDesc', { name: currentParticipant.firstName })
            : $t('option.descriptionDisqualify', { name: currentParticipant.firstName }) }}
        </p>
        <p v-if="isRemoveSelected" class="remove-caution text-center error--text font-weight-bold">
          {{ $t('removeCautionIrreversible') }}
        </p>
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('option.btnAll') }}</v-btn>
          <v-btn v-if="view === 'DISQUALIFY' && isRemoveSelected" class="ml-3" color="error" @click="removeUser">
            {{ $t('btnRemoveParticipant') }}</v-btn>
          <v-btn v-else-if="view === 'DISQUALIFY'" class="ml-3" @click="disqualifyUser">{{ $t('option.btnDisqualify', {
            name:
              currentParticipant.firstName }) }}</v-btn>
          <v-btn v-else class="ml-3" @click="activateUser">{{ $t('option.btnActivate', {
            name:
              currentParticipant.firstName })
            }}</v-btn>
        </v-row>
      </v-container>
    </v-card-text>

    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          {{ $t('btnClose_TournamentParticipants') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import RepositoryTournament from '../../../repositories/tournament';
import RepositoryBroker from '../../../repositories/brokerAccount';
import RepositoryClub from '../../../repositories/club';
import DisqualificationTooltip from '@/components/DisqualificationTooltip.vue';
import { mapMutations } from 'vuex';
export default {
  name: "TournamentParticipants",
  components: {
    DisqualificationTooltip
  },
  props: {
    tournamentSummary: Object,
    initialView: {
      type: String,
      default: 'GENERAL',
    },
  },
  data() {
    return {
      canSeeJournal: false,
      overlayProcessing: false,
      view: this.initialView,
      search: '',
      headers: [],

      // Full participant list (SFB-1217). The overview keeps only the current
      // server page in the store, so this overlay fetches every participant
      // itself; null means "not loaded — fall back to the store page".
      allParticipants: null,
      loadingParticipants: false,

      // Add Participant
      userId: 0,
      brokerAccountId: 0,
      userVerifiedBrokerAccounts: [],

      // Change Status
      currentParticipant: null,
      // SFB-1205: DISQUALIFY (reversible) vs REMOVE (permanent, pre-start only)
      memberActionChoice: 'DISQUALIFY',

      // Snackbar
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'mainGreen',
    };
  },
  mounted() {
    this.verifyCanSeeJournal();
    this.setHeaders();
    this.fetchAllParticipants();
    if (this.initialView === 'ADD') {
      this.fetchClubMembers();
    }
  },
  computed: {
    // SFB-1199: manual disqualification and activation are blocked once the
    // competition ends (supersedes the SFB-906 14-day grace window).
    tournamentEnded() {
      return new Date(this.$store.state.tournament.endTime) <= new Date();
    },
    // Full list when the admin service answered; the store's (paginated)
    // participants otherwise, so non-admin callers keep working.
    participantsList() {
      return this.allParticipants ?? this.$store.state.tournament.participants ?? [];
    },
    // SFB-1205: removal is only offered (and only accepted by the backend)
    // before the competition starts.
    tournamentNotStarted() {
      const startTime = this.$store.state.tournament?.startTime;
      return !!startTime && new Date(startTime) > new Date();
    },
    isRemoveSelected() {
      return this.view === 'DISQUALIFY'
        && this.tournamentNotStarted
        && this.memberActionChoice === 'REMOVE';
    },
  },

  methods: {
    getStatus(status) {
      if (status !== null) {
        switch (status) {
          case 'ACTIVE':
            return this.$t('status_TournamentParticipants.active');
          case 'DISQUALIFIED':
            return this.$t('status_TournamentParticipants.disqualified');
          case 'PAUSED':
            return this.$t('status_TournamentParticipants.paused');
          case 'WINNER':
            return this.$t('status_TournamentParticipants.winner');
        }
      }
    },
    setHeaders() {
      this.headers =[
        { text: this.$t('headers.name'), align: 'left', value: 'firstName', sortable: false },
        { text: this.$t('headers.email'), align: 'left', value: 'email', sortable: false },
        { text: this.$t('headers.brokerAccountId'), align: 'left', value: 'brokerAccountIdentifier', sortable: false },
        { text: this.$t('headers.username'), align: 'left', value: 'username', sortable: false },
        { text: this.$t('headers.score'), align: 'left', value: 'score', sortable: false },
        { text: this.$t('headers.status'), align: 'left', value: 'status', sortable: false, filterable: false },
        { text: this.$t('headers.actions'), align: 'right', value: 'actions', sortable: false, filterable: false },
      ]
    },
    verifyCanSeeJournal() {
      let startTime = new Date(this.$store.state.tournament.startTime);
      let endTime = new Date(this.$store.state.tournament.endTime);
      endTime.setDate(endTime.getDate() + 7);
      this.canSeeJournal = startTime < new Date() && new Date() < endTime;
    },
    ...mapMutations(['setTournament', 'setClubMembers']),
    async fetchClubMembers() {
      const clubId = this.$store.state.tournament?.tournamentOrganizerId
        || this.$store.state.tournament?.creator?.id
        || this.$store.state.clubMember?.club?.id;
      if (!clubId) return;
      try {
        const res = await RepositoryClub.getAllClubMembers(clubId);
        if (res && res.status < 400 && Array.isArray(res.data)) {
          this.setClubMembers(res.data);
        }
      } catch (_) {
        // silent — autocomplete will just show "No data available"
      }
    },
    openAddView() {
      this.view = 'ADD';
      this.fetchClubMembers();
    },
    // Loads the FULL participant list through the paginated admin service
    // (SFB-1217): the overview only keeps the current 10-row page in the
    // store, which made this "see all" view, its search and its CSV export
    // operate on a single page. Falls back to the store page when the admin
    // endpoint rejects the caller (non-admin entry points).
    async fetchAllParticipants() {
      const tournamentId = this.$store.state.tournament?.tournamentId;
      if (!tournamentId) return;
      this.loadingParticipants = true;
      try {
        const response = await RepositoryTournament.getTournamentAdminParticipants(tournamentId, 0, 5000, '');
        if (response.status < 400 && Array.isArray(response.data?.participants)) {
          this.allParticipants = response.data.participants;
        }
      } catch (error) {
        // 403 for non-admin viewers — keep the store fallback silently.
        if (error?.response?.status !== 403) {
          // eslint-disable-next-line no-console
          console.error('Error loading all participants:', error);
        }
      } finally {
        this.loadingParticipants = false;
      }
    },

    // After an add / disqualify / activate: refresh this overlay's full list
    // and tell the overview to re-fetch its paginated table and counters.
    refreshAfterChange() {
      this.fetchAllParticipants();
      this.$emit('participantsChanged');
      if (this.allParticipants === null) {
        // Non-admin fallback still depends on the store being re-hydrated.
        this.updateTournament();
      }
    },

    updateTournament() {
      RepositoryTournament.getTournamentOverview(this.$store.state.tournament.tournamentId).then((response) => {
        if (response.status < 400)
          this.setTournament(response.data);
      });
    },
    ...mapMutations(['setShare']),
    seeJournal(participant) {
      let sharingDetails = {
        id: participant.userId,
        username: participant.username,
        imageUrl: participant.imageUrl,
        firstName: participant.firstName,
        lastName: participant.lastName,
        country: participant.country,
        allowComments: false,
      };
      this.setShare(sharingDetails);
      this.$router.push('/book/shared');
    },
    async changedSelectedUser() {
      this.userVerifiedBrokerAccounts = [];
      let alreadyEnrolled;

      await RepositoryTournament.findParticipantByTournament(this.tournamentSummary.tournamentId, this.userId).then(async (response) => {
        if (response.status < 400)
          alreadyEnrolled = await response.data !== null;
      });

      if (alreadyEnrolled) {
        this.snackbarText = this.$t('alerts_TournamentParticipants.alreadyEnrolled');
        this.snackbarColor = 'error';
        this.snackbar = true;
      } else
        RepositoryBroker.allBrokerAccountsOfExternalUser(this.userId).then((response) => {
          if (response.status < 400) {
            this.userVerifiedBrokerAccounts = response.data.filter((account) => account.verified);
            if (this.userVerifiedBrokerAccounts.length === 0) {
              this.snackbarText = this.$t('alerts_TournamentParticipants.notVerified');
              this.snackbarColor = 'error';
              this.snackbar = true;
            }
          }
        });
    },
    ...mapMutations(['setTournament']),
    addParticipant() {
      this.overlayProcessing = true;
      let tournamentParticipant = {
        tournament: { id: this.tournamentSummary.tournamentId },
        assignedAccount: { id: this.brokerAccountId },
        user: { id: this.userId },
      };

      RepositoryTournament.enrollParticipant(tournamentParticipant).then((response) => {
        if (response.status < 400) {
          this.snackbarText = this.$t('alerts_TournamentParticipants.added', { userId: this.userId });
          this.snackbarColor = 'mainGreen';
          this.snackbar = true;
          this.refreshAfterChange();
          this.view = 'GENERAL';
        } else {
          this.showAddFailed();
        }
      }).catch((error) => {
        // The enroll endpoint 400s on any rejected business rule (already
        // enrolled, restricted account type, registration window for
        // non-managers, ...). Without this catch the axios rejection left the
        // processing overlay stuck with no feedback (SFB-1249).
        // eslint-disable-next-line no-console
        console.error('Error enrolling participant:', error);
        this.showAddFailed();
      }).finally(() => {
        this.overlayProcessing = false;
      });
    },

    showAddFailed() {
      this.snackbarText = this.$t('alerts_TournamentParticipants.addFailed');
      this.snackbarColor = 'error';
      this.snackbar = true;
    },
    goToUser(participant, action) {
      this.view = action;
      this.currentParticipant = participant;
      this.memberActionChoice = 'DISQUALIFY';
    },
    activateUser() {
      this.changeParticipantStatus('ACTIVE', 'activated');
    },
    disqualifyUser() {
      this.changeParticipantStatus('DISQUALIFIED', 'disqualified');
    },
    // SFB-1205: permanent removal — same member action, dedicated backend path.
    // The backend re-validates the pre-start window and answers 409 otherwise.
    removeUser() {
      this.overlayProcessing = true;
      RepositoryTournament.removeTournamentParticipant(
        this.$store.state.tournament.tournamentId,
        this.currentParticipant.participantId,
        null,
      ).then((response) => {
        if (response.status < 400) {
          this.snackbarText = this.$t('participantRemoved');
          this.snackbarColor = 'mainGreen';
          this.snackbar = true;
          this.refreshAfterChange();
          this.view = 'GENERAL';
        } else {
          this.showStatusChangeFailed();
        }
      }).catch((error) => {
        if (error?.response?.status === 409) {
          this.snackbarText = this.$t('removeOnlyBeforeStart');
          this.snackbarColor = 'error';
          this.snackbar = true;
        } else {
          // eslint-disable-next-line no-console
          console.error('Error removing participant:', error);
          this.showStatusChangeFailed();
        }
      }).finally(() => {
        this.overlayProcessing = false;
      });
    },
    // Shared status-change flow (SFB-1217): both actions hit the same service;
    // failures now clear the processing overlay and surface an error snackbar
    // instead of leaving the spinner stuck.
    changeParticipantStatus(newStatus, successKey) {
      this.overlayProcessing = true;
      // The success copy interpolates the acted-on participant (the old code
      // passed the ADD-form's userId field, which is 0 in this flow).
      const participantLabel = this.currentParticipant?.firstName
        || this.currentParticipant?.username
        || this.currentParticipant?.userId
        || '';
      RepositoryTournament.changeParticipantStatus(this.currentParticipant.participantId, newStatus).then((response) => {
        if (response.status < 400) {
          this.snackbarText = this.$t(`alerts_TournamentParticipants.${successKey}`, { userId: participantLabel });
          this.snackbarColor = 'mainGreen';
          this.snackbar = true;
          this.refreshAfterChange();
          this.view = 'GENERAL';
        } else {
          this.showStatusChangeFailed();
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error changing participant status:', error);
        this.showStatusChangeFailed();
      }).finally(() => {
        this.overlayProcessing = false;
      });
    },
    showStatusChangeFailed() {
      this.snackbarText = this.$t('alerts_TournamentParticipants.statusChangeFailed');
      this.snackbarColor = 'error';
      this.snackbar = true;
    },
    statusColor(status) {
      if (status === 'ACTIVE')
        return '#00F784';
      if (status === 'DISQUALIFIED')
        return '#ff9fa7';
      return '#FFF75F';
    },
    capitalize(string) {
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    },
    exportCSV() {
      let rows = [['Trader First Name', 'Trader Last Name', 'Trader Email', 'Score', 'Status'],];

      this.participantsList.forEach((participant) => {
        rows.push([
          `${participant.firstName}`,
          `${participant.lastName}`,
          `${participant.email}`,
          `${(participant.score === null) ? '0' : participant.score}`,
          `${participant.status}`,
        ]);
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

      // Encoding and data downloading
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "Tournament Participants.csv");
      document.body.appendChild(link);
      link.click();
      this.snackbarText = this.$t('alerts_TournamentParticipants.successfulDownload', { members: rows.length - 1 });
      this.snackbarColor = 'mainGreen';
      this.snackbar = true;
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped lang="scss">
.member-action-choice {
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;

  .member-action-hint {
    font-size: 12px;
    opacity: 0.7;
    line-height: 1.3;
    text-align: left;
  }
}
</style>
